import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';

import { isInternalNavigationPath } from './route-examiner';

const DynamicRouteLink = ({ to, href, children, ...props }) => {
	if (isInternalNavigationPath(to)) {
		return (
			<Link
				to={to}
				{...props}
			>
				{children}
			</Link>
		);
	}

	return (
		<a
			href={to}
			{...props}
			data-testid='a-link'
		>
			{children}
		</a>
	);
};

DynamicRouteLink.propTypes = {
	to: PropTypes.string,
	href: PropTypes.string,
	children: PropTypes.node.isRequired,
};

export default DynamicRouteLink;
